import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Auth0Provider } from '@auth0/auth0-react';
import { ChakraProvider } from '@chakra-ui/react';
import { ReforgeProvider } from '@reforge-com/react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
// OLD PROJECT IMPORTS
import ReduxToastr from 'react-redux-toastr';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import App from './App';
import { mfAdminChakraTheme } from './configs/mfChakraTheme';
import { REACT_APP_AUTH0_DOMAIN as auth0Domain, REACT_APP_AUTH0_CLIENT_ID as auth0ClientId, REACT_APP_AUTH0_REDIRECT_URI as auth0RedirectUri, TOASTR_TIMEOUT as toastTimeout, REFORGE_FRONTEND_SDK_KEY as reforgeSdkKey } from './Constants';
import { MFAdminAppInitializerProvider } from './contexts/MFAdminAppInitializer';
import { store } from './redux/storeConfig/store';
import { ThemeContext } from './utility/context/ThemeColors';
// ** Core styles
import './@core/assets/fonts/feather/iconfont.css';
import './@core/scss/core.scss';
import './assets/scss/style.scss';
import './index.css';
const appRootContainer = document.getElementById('root');
if (!appRootContainer)
    throw new Error('Root element not found');
const root = createRoot(appRootContainer);
root.render(_jsx(BrowserRouter, { basename: "/", children: _jsx(ChakraProvider, { theme: mfAdminChakraTheme, children: _jsx(MFAdminAppInitializerProvider, { children: _jsx(Provider, { store: store, children: _jsx(Auth0Provider, { domain: auth0Domain, clientId: auth0ClientId, authorizationParams: {
                        redirect_uri: auth0RedirectUri
                    }, children: _jsxs(ReforgeProvider, { sdkKey: reforgeSdkKey, onError: reason => console.error('Reforge error:', reason), children: [_jsx(ReduxToastr, { timeOut: toastTimeout, newestOnTop: false, preventDuplicates: true, position: "top-center", transitionIn: "fadeIn", transitionOut: "fadeOut", progressBar: true, closeOnToastrClick: true }), _jsxs(ThemeContext, { children: [_jsx(App, {}), _jsx(ToastContainer, { newestOnTop: true })] })] }) }) }) }) }) }));
